import { render } from "./Home copy 2.vue?vue&type=template&id=4091f598&scoped=true"
import script from "./Home copy 2.vue?vue&type=script&lang=js"
export * from "./Home copy 2.vue?vue&type=script&lang=js"

import "./Home copy 2.vue?vue&type=style&index=0&id=4091f598&lang=scss&scoped=true"

import exportComponent from "E:\\code\\项目代码\\温州科技馆\\科技馆公众号\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4091f598"]])

export default __exports__